<template lang="pug">
.agereement-text
  p Я, {{ $user.data.info.full_name }},
    |  в соответствии с требованием статьи 9 Федерального закона от 27.07.2006 г. №152-ФЗ «О
    | персональных данных» в целях организации обучения по выбранной образовательной
    | программе даю свое согласие оператору персональных данных
    strong  "{{ organization.full_name }}"
    |  ({{ organization.payment_inn }}, юридический адрес: "{{ organization.address_legal }}")
    | на осуществление обработки следующих
    | своих персональных данных
  p Предоставляю право осуществлять обработку с использованием средств
    | автоматизации или без использования таких средств, включая сбор, запись,
    | систематизацию, накопление, хранение, уточнение (обновление, изменение),
    | извлечение, использование, обезличивание, блокирование, удаление, уничтожение
    | персональных данных в целях, определенных настоящим согласием.
    | Данное Согласие действует с момента подписания и до истечения сроков, установленных
    | действующим законодательством Российской Федерации, а также может быть отозвано
    | по письменному заявлению.
  ul
    li Фамилия
    li Имя
    li Отчество
    li(v-for="attr in attributes" :key="attr.id") {{ attr.name }}
</template>

<script>
export default {
  props: {
    attributes: { type: Array, required: true },
    organization: { type: Object, required: true },
  },
};
</script>
